export default function ImagePreview({ image }) {
  return image ? (
    <>
      <img src={image.url} style={{ width: 200 }} />
    </>
  ) : null
}
